define('specific/staticproduct/models/StaticProductModel', [

], function() {

    var StaticProductModel = Backbone.Model.extend({
        defaults: {
            type: "staticproduct",
            viewId: "",
            datas: null,
            isReady: false
        }
    });

    return StaticProductModel;
});
